<ul class="medications_list">
  @for (medication of medications; track medication.id) {
    <li>
      <div>{{ medication.title }}</div>
      @if (medication.description) {
        <common-rich-text-view class="medications_list-item-description" [content]="medication.description" />
      }
    </li>
  }
</ul>
